import gql from 'graphql-tag';

export const DELETE_SUMMARY_FEEDBACK_ITEM = gql`
  mutation deleteSummaryFeedbackConfiguration($contentSnippetSummaryId: Int!) {
    summaryFeedback {
      deleteSummaryFeedbackConfiguration(contentSnippetSummaryId: $contentSnippetSummaryId)
    }
  }
`;
